
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexNcZW9mO7q_yZKrJuS6MNKyRCMrLANq_45cVZG0dTNkAOoMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/index.vue?macro=true";
import { default as loginIn1BtUocfPM416Ly_45jLW7W_45GoGFb7z5xiWkoJTLsB9kMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/login.vue?macro=true";
import { default as logout89xEYEWEjzK9l2k76qCgCfKkueWVdyTBIDF1m7gu_PkMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/logout.vue?macro=true";
import { default as tagsEQM6x0W_45U9jf26TBU_45J4g0meiKs_soXjN3W8zNViYfoMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/tags.vue?macro=true";
import { default as index_X8D_45gslBXe7W3a_451U_k7FzCEbAcepZvcsOxR7pOxU8Meta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/index.vue?macro=true";
import { default as login_45callbackEMTAH51mKKIhjRVLQuDnGn9_VGkXYovNGnZHqtGidG0Meta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/login-callback.vue?macro=true";
import { default as reset_45passworduuWUqzhxwnTEytDPtqlmN1BUDApg7EOmoQ_45TP57FexIMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/reset-password.vue?macro=true";
import { default as tagswsKgz6uor9Ev9_45wSDsHhLJnu9qsybPJTESecDBaCOyQMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/tags.vue?macro=true";
import { default as indexhjADlif0WRiRmevetWOwAW7c7hFs2OUMK3SH8RebnRoMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/index.vue?macro=true";
import { default as indexCICBbp1jagWRxL9Vr2M23uUrChNriNmjUb5cjjQjRJYMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/users/index.vue?macro=true";
import { default as indexH92dg6zIiTlGEN3Q6ZZJOEilT94MzNvy_ItHJYeTqyoMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/modules/index.vue?macro=true";
import { default as indexEhLLJLyGfRnecs2q0rg3txPId2UJISnMUbgDoNz5skAMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/templates/index.vue?macro=true";
import { default as _91user_id_93tXglYz5FophKp__45s2GWIXVJU3dHClsYA5VNJaWQ_fPMMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/users/[user_id].vue?macro=true";
import { default as funding_45entitiesjyBKETJgQOKkZxWMXMyc7nGiQv74nB70suldmEujt0MMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/funding-entities.vue?macro=true";
import { default as _91module_id_930_3XFcwR4l26JnIx_45gYAwyUpNZQKC6ZIDz14iDvqibAMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/modules/[module_id].vue?macro=true";
import { default as indexJobKt_FviW3CJTuVIdSRJPXkw5krJur6re2GRXgIbaUMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/templates/memos/index.vue?macro=true";
import { default as indexO1nSG3cqwImOOSkerkjHtXRejctu2EdATBdLFNgLZlcMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/templates/notes/index.vue?macro=true";
import { default as newMCs81PQ5jmIrCTgVqKnZLv6n9KjTl20aTNa89Cv0V60Meta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/templates/opportunities/new.vue?macro=true";
import { default as indexUR55KuJHT5nVe3C_p7mW_45C4cQZ8Oub4sBHHOKCrGW2gMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/templates/opportunities/index.vue?macro=true";
import { default as _91template_id_93o54KSmoobdYY_45l9TYUEo8Uo8yFJYfmSZMp8KqczSupQMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/templates/opportunities/[template_id].vue?macro=true";
import { default as adminbOrkm9dJDI__aQ8oPjvGK811l68bJzGco7JaS9v8mKMMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin.vue?macro=true";
import { default as indexeVvFyGRYEdHcA693rZgjv49UpHJpWwfrRPDvh3Kfa1YMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/index.vue?macro=true";
import { default as index_3pRAEvvPmVXweMN5jYcjErt6TDif0Ne9dcOS7o5GQIMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/users/index.vue?macro=true";
import { default as indexf7xLJlQulnhtQupXDeNfPSn0sq2MaDm6IOcUhV8qzrgMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/clients/index.vue?macro=true";
import { default as indexOck2_WWlWFdCHuDkSX19F_45eoBnG5onmkwrNwp13rHZIMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/modules/index.vue?macro=true";
import { default as indextyTvgRT1CbOlV8KaPdG05cw4_6I8P0RFCJ6R0X_r_pkMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/templates/index.vue?macro=true";
import { default as _91user_id_93Uaz9o9KdCYS06KPdZndRWm1wfWx_45tOEwyKcolAozBtkMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/users/[user_id].vue?macro=true";
import { default as indexRI60_45KoUpZUsHpE5zvO4aTIIpfngk0wdxsI5XX_45guikMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/plan/index.vue?macro=true";
import { default as indexs7phfm633UqvWnWOjGkXJQPv4joh_45C98Ncnvyek5Xb4Meta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/user/index.vue?macro=true";
import { default as notesWodxFBmd_UOS_45lEa0RfvHWgGunV5gXwtirAZIk1zSisMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/user/notes.vue?macro=true";
import { default as tasksWJEXRi_KHM1UNOMMz4ZV5UDllE_RiCHdtlLdQ9Lq_45LMMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/user/tasks.vue?macro=true";
import { default as indext8xnX2USdeAGTGQmin9_V1pn4_45Hyl_45jQ05Ne_5fm_MgMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/users/index.vue?macro=true";
import { default as reset_45password_45callbackYmp9wS2uBcPGijKLeylTcpms8gmbmutMX1DWWTwINAIMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/reset-password-callback.vue?macro=true";
import { default as indexvMgsmw8i_45NvnxcQGwEG2wh8BaSRrzp1cb_45cNJkEUgbAMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/search/index.vue?macro=true";
import { default as indexln3gLFtcjMlYNObdNZWouSUzs1gLrzQ_457au8D29Ud5AMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/index.vue?macro=true";
import { default as indexqfVm760asFlqB7fFfHkEIrDGKdPazmWLC2Az_45GRXeDMMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/monitor/index.vue?macro=true";
import { default as _91module_id_93thbWh_45VtRXedo7HNbA04MdetZ2mh_45iNROePubR3rajIMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/modules/[module_id].vue?macro=true";
import { default as indexq1sT1m9MIrynCHpQFOZKgxZZDkt5dK4nLZkCmVGgi5cMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/index.vue?macro=true";
import { default as indexTs7vtbvHpGRyEh89_ShkuIjEGyHAfMGfFvoycY_45vx4wMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/plan/saa/index.vue?macro=true";
import { default as favoritesxfS8TRLw1XHm8yNyekq_yVRTiHVgVggBuf89d_TKGcEMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/user/favorites.vue?macro=true";
import { default as data_45extraction1JX6KPLHJOQPDOYe6rDt3sVZ2JXHwCXCfgqYupo0pNoMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/data-extraction.vue?macro=true";
import { default as dealsE3IC5XxA_458f_EOXBBogMspwAlT0zUsQX80k_45RY2EgoUMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/pe/deals.vue?macro=true";
import { default as fundswiDChpyzH0Y4eptShkJhjYzU_45n1LZoQejRuUTTRyExEMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/pe/funds.vue?macro=true";
import { default as indexy5jXholfI7kgkF2aSDG1_8zTWcneBwFWjY2iE6vdQ1QMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/pe/index.vue?macro=true";
import { default as dealsfRKYpHd3vgJ_8rIvw0987TIG2ItoV3yAJcTz_tJ9mZIMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/vc/deals.vue?macro=true";
import { default as indexBVNw4RKK_45hSiyogdnmQu1bEUsQLgJNKnixnSkU2FRx4Meta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/vc/index.vue?macro=true";
import { default as _91user_id_93y39U3DJlARSs9kT92d6BzPlGucaKS3U3kZW6XIZjpZcMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/users/[user_id].vue?macro=true";
import { default as indexU4Xk28vUmtPoUKtQqZNedorxRF1KccrvAHKfa_fYdBkMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/data-extraction/index.vue?macro=true";
import { default as indexAFM1PMdI7Oysv18qPmmSNutIsf2L3U0ezuucXLl2xsYMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/templates/memos/index.vue?macro=true";
import { default as indexkDZOGt607grjeFnTKQZlCZ5nFwRt9Rh4z64fuhr6pqEMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/templates/notes/index.vue?macro=true";
import { default as indexuSQdjX_3Qfwdnvnte_T7LF9aRK4bUsJWHjI3n9sIRNUMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/market-map/index.vue?macro=true";
import { default as trackingJreaay1DgbFwLRMhMjzseafUoiyHP6ZOKQHcZUThkN8Meta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/monitor/tracking.vue?macro=true";
import { default as people_45pQLKYPoCBQqEj5Nq3jvzuOymoyTrFQnS_4526aXMFs4IMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/pe/people.vue?macro=true";
import { default as peoplerA8Gef1Cl8UO2Y_45jj64c8hXS_45wvUm0vDzGKxD2RJJOoMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/vc/people.vue?macro=true";
import { default as companiesHDjdWn_8lWLnedpHwzH7V58459_0kDzZXx25mhqnDfkMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/vc/companies.vue?macro=true";
import { default as index73t7ItC6jBYTN_45_pBUOtUJo5KSLQ677HdX9vfgyJnOsMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/clients/[client_id]/index.vue?macro=true";
import { default as benchmarkingqaUPpcYhnThQQZcqN_45m8BtjXqorW6ldWimDk7P2WkMAMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/monitor/benchmarking.vue?macro=true";
import { default as indexo4sW7rx7zzY2xBxIdX7rG1y8yc7c30wHlP2dIPJEhTcMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/plan/liquidity/index.vue?macro=true";
import { default as newkqWQ8ScwNB_45yHY4u3JWKTtHKiunEWuu63SMgaKKpGCwMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/templates/opportunities/new.vue?macro=true";
import { default as index3gOLWyS80U8b52t4Ji8go4UJYRTuTts9o3k3vqXYrTsMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/plan/saa/[saa_id]/index.vue?macro=true";
import { default as index_83EozMts8s3ZyYVbsnil3Ei67ZnYNFB5hgrSYh1Oa4Meta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/templates/opportunities/index.vue?macro=true";
import { default as market_map_fundsIckYNdm85PtQSwZLBW30DzN73xxg0_45uNLW766RJoOioMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/market-map/market_map_funds.js?macro=true";
import { default as investment_45firmsFoGQjX0Y2TJ6Qs1fgWH5EEYH7DO8i8I9mLriTg8_W8oMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/pe/investment-firms.vue?macro=true";
import { default as inviteejpO9OFq7f2N5_1yBuMiwklwYZG37tmjjG_9ylK0MfYMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/clients/[client_id]/users/invite.vue?macro=true";
import { default as indexybYTUKemZO6SjNQMA9LK1oHfvAibee7PiArvI9p7QMQMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/index.vue?macro=true";
import { default as dataBUQm7TiGEvn7qVB5_aP5EWqnHO3po_FU13eH7QuJ6twMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/plan/liquidity/[liquidity_id]/data.vue?macro=true";
import { default as indexoP3yRiDdb_MGoCejQApA_dqMl8afxSfZbdB6nvy2yJIMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/plan/liquidity/[liquidity_id]/index.vue?macro=true";
import { default as _91liquidity_id_93KcEw770lEJPA3oQp8A_XeVUDsJ8Z99LUyUXqRGJjFw0Meta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/plan/liquidity/[liquidity_id].vue?macro=true";
import { default as _91user_id_93topgEWq9INQvQe_45ObEKkdXB_6rql3xWH0nltXL1Tx_45YMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/clients/[client_id]/users/[user_id].vue?macro=true";
import { default as _91data_extraction_id_93uDI039fruBskh6w7wHeKoV6goz8Zc5xU76vqaeniC_UMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/data-extraction/[data_extraction_id].vue?macro=true";
import { default as invite_45bulkTna87_453qKYPKEKPqGsH2b4pAQPgrVoT3Ee8GZIEWDQ4Meta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/clients/[client_id]/users/invite-bulk.vue?macro=true";
import { default as _91template_id_93Xk198V344ZrZNjhc7dA8ew_tFhwIA3zG6dDN8JFY4TMMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/templates/opportunities/[template_id].vue?macro=true";
import { default as indexVdcoanRm9trOWoqva1zgm3EVjvXYJUIUUBXYg5sejH4Meta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/vc/investment-firms/index.vue?macro=true";
import { default as indexzNQPMk4uPllpstEQwR2WP5DKTUeeMbkc0TwNeFq8jj0Meta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/monitor/[funding_entity_id]/index.vue?macro=true";
import { default as _91module_id_93yY5Pi2GZAFiaJYJOOknxP8NHKuVmz1Czw7aZ0i_45nk9EMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/clients/[client_id]/modules/[module_id].vue?macro=true";
import { default as _91investment_firm_id_93nXn0nZUWlCX9ilecqtptqlYtlxjm3m4kUh0mU2lmwpIMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/vc/investment-firms/[investment_firm_id].vue?macro=true";
import { default as memoVz71_45V75ss_45sYXiE3_452aaAXbcx8Han0o1XN1saRk4wQMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/memo.vue?macro=true";
import { default as indexXztbEMgIfUN8CH1S0MbP7EKcy7wBNyHFBQ0M1Mn7gOEMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/index.vue?macro=true";
import { default as settings2oeSEuQJy01oJddSErX7zfwaA8tyce7C24naEIloCSsMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/settings.vue?macro=true";
import { default as analyticsE6ZfHsu7GVBkmPVd7ZREK5KVyRIXLBTZcSVjdfVmMsEMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/analytics.vue?macro=true";
import { default as data_45room_45qlDfWt7oFNtFGVVrY4UbA_45aEhNDwve27Be5faZo4Y8Meta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/data-room.vue?macro=true";
import { default as scorecardEOHfPV_yyJhDnqVbxp0OQ_45EtQnxMHEDD8zU74iUqY5kMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/scorecard.vue?macro=true";
import { default as index_457NWiBPQw00tBgUT06V9cv0qpO4coyuJzLhyCBWMLHkMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/memos/index.vue?macro=true";
import { default as data_45extractionJmEPXaJBBnOEXglTm4o_dIZjuzSwKxCQjmLdKdGzrxkMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/data-extraction.vue?macro=true";
import { default as _91memo_id_93ENWmm15GuzuLCRqPOF3SOuhMONBQDtws7m4hb_457L_45WEMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/memos/[memo_id].vue?macro=true";
import { default as _91data_room_id_93klZX8l8AGI8XTyvfUXnuPqIeEbHQxqexrK1RUp8tbPoMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id].vue?macro=true";
import { default as funding_45entity_45data_45editor_45hierarchyODScAWn4NSe5vJE5RTNslfneMumMKb_xBo3FZxajFAkMeta } from "/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/monitor/[funding_entity_id]/funding-entity-data-editor-hierarchy.ts?macro=true";
export default [
  {
    name: "index___en",
    path: "/",
    meta: indexNcZW9mO7q_yZKrJuS6MNKyRCMrLANq_45cVZG0dTNkAOoMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: loginIn1BtUocfPM416Ly_45jLW7W_45GoGFb7z5xiWkoJTLsB9kMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/login.vue")
  },
  {
    name: "logout___en",
    path: "/logout",
    meta: logout89xEYEWEjzK9l2k76qCgCfKkueWVdyTBIDF1m7gu_PkMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/logout.vue")
  },
  {
    name: "admin-tags___en",
    path: "/admin/tags",
    meta: tagsEQM6x0W_45U9jf26TBU_45J4g0meiKs_soXjN3W8zNViYfoMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/tags.vue")
  },
  {
    name: "admin___en",
    path: "/admin",
    meta: index_X8D_45gslBXe7W3a_451U_k7FzCEbAcepZvcsOxR7pOxU8Meta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/index.vue")
  },
  {
    name: "login-callback___en",
    path: "/login-callback",
    meta: login_45callbackEMTAH51mKKIhjRVLQuDnGn9_VGkXYovNGnZHqtGidG0Meta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/login-callback.vue")
  },
  {
    name: "reset-password___en",
    path: "/reset-password",
    meta: reset_45passworduuWUqzhxwnTEytDPtqlmN1BUDApg7EOmoQ_45TP57FexIMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/reset-password.vue")
  },
  {
    name: adminbOrkm9dJDI__aQ8oPjvGK811l68bJzGco7JaS9v8mKMMeta?.name,
    path: "/:client_id()/admin",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin.vue"),
    children: [
  {
    name: "client_id-admin-tags___en",
    path: "tags",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/tags.vue")
  },
  {
    name: "client_id-admin___en",
    path: "",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/index.vue")
  },
  {
    name: "client_id-admin-users___en",
    path: "users",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/users/index.vue")
  },
  {
    name: "client_id-admin-modules___en",
    path: "modules",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/modules/index.vue")
  },
  {
    name: "client_id-admin-templates___en",
    path: "templates",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/templates/index.vue")
  },
  {
    name: "client_id-admin-users-user_id___en",
    path: "users/:user_id()",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/users/[user_id].vue")
  },
  {
    name: "client_id-admin-funding-entities___en",
    path: "funding-entities",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/funding-entities.vue")
  },
  {
    name: "client_id-admin-modules-module_id___en",
    path: "modules/:module_id()",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/modules/[module_id].vue")
  },
  {
    name: "client_id-admin-templates-memos___en",
    path: "templates/memos",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/templates/memos/index.vue")
  },
  {
    name: "client_id-admin-templates-notes___en",
    path: "templates/notes",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/templates/notes/index.vue")
  },
  {
    name: "client_id-admin-templates-opportunities-new___en",
    path: "templates/opportunities/new",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/templates/opportunities/new.vue")
  },
  {
    name: "client_id-admin-templates-opportunities___en",
    path: "templates/opportunities",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/templates/opportunities/index.vue")
  },
  {
    name: "client_id-admin-templates-opportunities-template_id___en",
    path: "templates/opportunities/:template_id()",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/admin/templates/opportunities/[template_id].vue")
  }
]
  },
  {
    name: "client_id___en",
    path: "/:client_id()",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/index.vue")
  },
  {
    name: "admin-users___en",
    path: "/admin/users",
    meta: index_3pRAEvvPmVXweMN5jYcjErt6TDif0Ne9dcOS7o5GQIMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/users/index.vue")
  },
  {
    name: "admin-clients___en",
    path: "/admin/clients",
    meta: indexf7xLJlQulnhtQupXDeNfPSn0sq2MaDm6IOcUhV8qzrgMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/clients/index.vue")
  },
  {
    name: "admin-modules___en",
    path: "/admin/modules",
    meta: indexOck2_WWlWFdCHuDkSX19F_45eoBnG5onmkwrNwp13rHZIMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/modules/index.vue")
  },
  {
    name: "admin-templates___en",
    path: "/admin/templates",
    meta: indextyTvgRT1CbOlV8KaPdG05cw4_6I8P0RFCJ6R0X_r_pkMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/templates/index.vue")
  },
  {
    name: "admin-users-user_id___en",
    path: "/admin/users/:user_id()",
    meta: _91user_id_93Uaz9o9KdCYS06KPdZndRWm1wfWx_45tOEwyKcolAozBtkMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/users/[user_id].vue")
  },
  {
    name: "client_id-plan___en",
    path: "/:client_id()/plan",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/plan/index.vue")
  },
  {
    name: "client_id-user___en",
    path: "/:client_id()/user",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/user/index.vue")
  },
  {
    name: "client_id-user-notes___en",
    path: "/:client_id()/user/notes",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/user/notes.vue")
  },
  {
    name: "client_id-user-tasks___en",
    path: "/:client_id()/user/tasks",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/user/tasks.vue")
  },
  {
    name: "client_id-users___en",
    path: "/:client_id()/users",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/users/index.vue")
  },
  {
    name: "reset-password-callback___en",
    path: "/reset-password-callback",
    meta: reset_45password_45callbackYmp9wS2uBcPGijKLeylTcpms8gmbmutMX1DWWTwINAIMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/reset-password-callback.vue")
  },
  {
    name: "client_id-search___en",
    path: "/:client_id()/search",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/search/index.vue")
  },
  {
    name: "client_id-source___en",
    path: "/:client_id()/source",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/index.vue")
  },
  {
    name: "client_id-monitor___en",
    path: "/:client_id()/monitor",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/monitor/index.vue")
  },
  {
    name: "admin-modules-module_id___en",
    path: "/admin/modules/:module_id()",
    meta: _91module_id_93thbWh_45VtRXedo7HNbA04MdetZ2mh_45iNROePubR3rajIMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/modules/[module_id].vue")
  },
  {
    name: "client_id-pipeline___en",
    path: "/:client_id()/pipeline",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/index.vue")
  },
  {
    name: "client_id-plan-saa___en",
    path: "/:client_id()/plan/saa",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/plan/saa/index.vue")
  },
  {
    name: "client_id-user-favorites___en",
    path: "/:client_id()/user/favorites",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/user/favorites.vue")
  },
  {
    name: "client_id-data-extraction___en",
    path: "/:client_id()/data-extraction",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/data-extraction.vue")
  },
  {
    name: "client_id-source-pe-deals___en",
    path: "/:client_id()/source/pe/deals",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/pe/deals.vue")
  },
  {
    name: "client_id-source-pe-funds___en",
    path: "/:client_id()/source/pe/funds",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/pe/funds.vue")
  },
  {
    name: "client_id-source-pe___en",
    path: "/:client_id()/source/pe",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/pe/index.vue")
  },
  {
    name: "client_id-source-vc-deals___en",
    path: "/:client_id()/source/vc/deals",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/vc/deals.vue")
  },
  {
    name: "client_id-source-vc___en",
    path: "/:client_id()/source/vc",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/vc/index.vue")
  },
  {
    name: "client_id-users-user_id___en",
    path: "/:client_id()/users/:user_id()",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/users/[user_id].vue")
  },
  {
    name: "admin-data-extraction___en",
    path: "/admin/data-extraction",
    meta: indexU4Xk28vUmtPoUKtQqZNedorxRF1KccrvAHKfa_fYdBkMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/data-extraction/index.vue")
  },
  {
    name: "admin-templates-memos___en",
    path: "/admin/templates/memos",
    meta: indexAFM1PMdI7Oysv18qPmmSNutIsf2L3U0ezuucXLl2xsYMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/templates/memos/index.vue")
  },
  {
    name: "admin-templates-notes___en",
    path: "/admin/templates/notes",
    meta: indexkDZOGt607grjeFnTKQZlCZ5nFwRt9Rh4z64fuhr6pqEMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/templates/notes/index.vue")
  },
  {
    name: "client_id-market-map___en",
    path: "/:client_id()/market-map",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/market-map/index.vue")
  },
  {
    name: "client_id-monitor-tracking___en",
    path: "/:client_id()/monitor/tracking",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/monitor/tracking.vue")
  },
  {
    name: "client_id-source-pe-people___en",
    path: "/:client_id()/source/pe/people",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/pe/people.vue")
  },
  {
    name: "client_id-source-vc-people___en",
    path: "/:client_id()/source/vc/people",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/vc/people.vue")
  },
  {
    name: "client_id-source-vc-companies___en",
    path: "/:client_id()/source/vc/companies",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/vc/companies.vue")
  },
  {
    name: "admin-clients-client_id___en",
    path: "/admin/clients/:client_id()",
    meta: index73t7ItC6jBYTN_45_pBUOtUJo5KSLQ677HdX9vfgyJnOsMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/clients/[client_id]/index.vue")
  },
  {
    name: "client_id-monitor-benchmarking___en",
    path: "/:client_id()/monitor/benchmarking",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/monitor/benchmarking.vue")
  },
  {
    name: "client_id-plan-liquidity___en",
    path: "/:client_id()/plan/liquidity",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/plan/liquidity/index.vue")
  },
  {
    name: "admin-templates-opportunities-new___en",
    path: "/admin/templates/opportunities/new",
    meta: newkqWQ8ScwNB_45yHY4u3JWKTtHKiunEWuu63SMgaKKpGCwMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/templates/opportunities/new.vue")
  },
  {
    name: "client_id-plan-saa-saa_id___en",
    path: "/:client_id()/plan/saa/:saa_id()",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/plan/saa/[saa_id]/index.vue")
  },
  {
    name: "admin-templates-opportunities___en",
    path: "/admin/templates/opportunities",
    meta: index_83EozMts8s3ZyYVbsnil3Ei67ZnYNFB5hgrSYh1Oa4Meta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/templates/opportunities/index.vue")
  },
  {
    name: "client_id-market-map-market_map_funds___en",
    path: "/:client_id()/market-map/market_map_funds",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/market-map/market_map_funds.js")
  },
  {
    name: "client_id-source-pe-investment-firms___en",
    path: "/:client_id()/source/pe/investment-firms",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/pe/investment-firms.vue")
  },
  {
    name: "admin-clients-client_id-users-invite___en",
    path: "/admin/clients/:client_id()/users/invite",
    meta: inviteejpO9OFq7f2N5_1yBuMiwklwYZG37tmjjG_9ylK0MfYMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/clients/[client_id]/users/invite.vue")
  },
  {
    name: "client_id-pipeline-pipeline_id___en",
    path: "/:client_id()/pipeline/:pipeline_id()",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/index.vue")
  },
  {
    name: _91liquidity_id_93KcEw770lEJPA3oQp8A_XeVUDsJ8Z99LUyUXqRGJjFw0Meta?.name,
    path: "/:client_id()/plan/liquidity/:liquidity_id()",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/plan/liquidity/[liquidity_id].vue"),
    children: [
  {
    name: "client_id-plan-liquidity-liquidity_id-data___en",
    path: "data",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/plan/liquidity/[liquidity_id]/data.vue")
  },
  {
    name: "client_id-plan-liquidity-liquidity_id___en",
    path: "",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/plan/liquidity/[liquidity_id]/index.vue")
  }
]
  },
  {
    name: "admin-clients-client_id-users-user_id___en",
    path: "/admin/clients/:client_id()/users/:user_id()",
    meta: _91user_id_93topgEWq9INQvQe_45ObEKkdXB_6rql3xWH0nltXL1Tx_45YMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/clients/[client_id]/users/[user_id].vue")
  },
  {
    name: "admin-data-extraction-data_extraction_id___en",
    path: "/admin/data-extraction/:data_extraction_id()",
    meta: _91data_extraction_id_93uDI039fruBskh6w7wHeKoV6goz8Zc5xU76vqaeniC_UMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/data-extraction/[data_extraction_id].vue")
  },
  {
    name: "admin-clients-client_id-users-invite-bulk___en",
    path: "/admin/clients/:client_id()/users/invite-bulk",
    meta: invite_45bulkTna87_453qKYPKEKPqGsH2b4pAQPgrVoT3Ee8GZIEWDQ4Meta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/clients/[client_id]/users/invite-bulk.vue")
  },
  {
    name: "admin-templates-opportunities-template_id___en",
    path: "/admin/templates/opportunities/:template_id()",
    meta: _91template_id_93Xk198V344ZrZNjhc7dA8ew_tFhwIA3zG6dDN8JFY4TMMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/templates/opportunities/[template_id].vue")
  },
  {
    name: "client_id-source-vc-investment-firms___en",
    path: "/:client_id()/source/vc/investment-firms",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/vc/investment-firms/index.vue")
  },
  {
    name: "client_id-monitor-funding_entity_id___en",
    path: "/:client_id()/monitor/:funding_entity_id()",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/monitor/[funding_entity_id]/index.vue")
  },
  {
    name: "admin-clients-client_id-modules-module_id___en",
    path: "/admin/clients/:client_id()/modules/:module_id()",
    meta: _91module_id_93yY5Pi2GZAFiaJYJOOknxP8NHKuVmz1Czw7aZ0i_45nk9EMeta || {},
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/admin/clients/[client_id]/modules/[module_id].vue")
  },
  {
    name: "client_id-source-vc-investment-firms-investment_firm_id___en",
    path: "/:client_id()/source/vc/investment-firms/:investment_firm_id()",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/source/vc/investment-firms/[investment_firm_id].vue")
  },
  {
    name: _91data_room_id_93klZX8l8AGI8XTyvfUXnuPqIeEbHQxqexrK1RUp8tbPoMeta?.name,
    path: "/:client_id()/pipeline/:pipeline_id()/opportunity/:data_room_id()",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id].vue"),
    children: [
  {
    name: "client_id-pipeline-pipeline_id-opportunity-data_room_id-memo___en",
    path: "memo",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/memo.vue")
  },
  {
    name: "client_id-pipeline-pipeline_id-opportunity-data_room_id___en",
    path: "",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/index.vue")
  },
  {
    name: "client_id-pipeline-pipeline_id-opportunity-data_room_id-settings___en",
    path: "settings",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/settings.vue")
  },
  {
    name: "client_id-pipeline-pipeline_id-opportunity-data_room_id-analytics___en",
    path: "analytics",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/analytics.vue")
  },
  {
    name: "client_id-pipeline-pipeline_id-opportunity-data_room_id-data-room___en",
    path: "data-room",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/data-room.vue")
  },
  {
    name: "client_id-pipeline-pipeline_id-opportunity-data_room_id-scorecard___en",
    path: "scorecard",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/scorecard.vue")
  },
  {
    name: "client_id-pipeline-pipeline_id-opportunity-data_room_id-memos___en",
    path: "memos",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/memos/index.vue")
  },
  {
    name: "client_id-pipeline-pipeline_id-opportunity-data_room_id-data-extraction___en",
    path: "data-extraction",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/data-extraction.vue")
  },
  {
    name: "client_id-pipeline-pipeline_id-opportunity-data_room_id-memos-memo_id___en",
    path: "memos/:memo_id()",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/pipeline/[pipeline_id]/opportunity/[data_room_id]/memos/[memo_id].vue")
  }
]
  },
  {
    name: "client_id-monitor-funding_entity_id-funding-entity-data-editor-hierarchy___en",
    path: "/:client_id()/monitor/:funding_entity_id()/funding-entity-data-editor-hierarchy",
    component: () => import("/Users/simon/Documents/equation-internal/app/frontend3/pages/[client_id]/monitor/[funding_entity_id]/funding-entity-data-editor-hierarchy.ts")
  }
]